module.exports = __webpack_public_path__ + "img/empty-work-schedule.8476eb78.webp";